import Vue from 'vue'
import Router from 'vue-router'
import ModelList from './pages/ModelList/views/ModelList.vue'
import m_ModelList from './pages/m_ModelList/views/ModelList.vue'
import Model from './pages/Model/views/Model.vue'
import m_Model from './pages/m_Model/views/Model.vue'
import upLoadFile from './pages/upLoadFile/views/upLoadFile.vue'
import infoPage from './pages/infoPage/views/infoPage.vue'



Vue.use(Router)

export default new Router({
  mode:"history",
  routes: [
    {
      path: '/ModelList.html',
      name: 'ModelList',
      component:ModelList,
    },
    {
      path: '/m_ModelList.html',
      name: 'm_ModelList',
      component:m_ModelList,
    },
    {
      path:'/Model.html',
      name:'Model',
      component:Model,
    },
    {
      path:'/m_Model.html',
      name:'m_Model',
      component:m_Model,
    },
    {
      path:'/upLoadFile.html',
      name:'upLoadFile',
      component:upLoadFile,
    },
    {
      path:'/infoPage.html',
      name:'infoPage',
      component:infoPage,
    }
  ]
})